import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-781c5ec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row h-100" }
const _hoisted_2 = {
  class: "d-md-block d-lg-flex d-sm-block justify-content-end px-5",
  style: {"padding-top":"50px"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12 col-lg-7 col-sm-12\" data-v-781c5ec4><div class=\"row h-100\" style=\"background-image:url(&#39;media/illustrations/sketchy-1/Grupo_235.svg&#39;);background-size:cover;background-repeat:no-repeat;background-position:-500px 0px !important;\" data-v-781c5ec4><div class=\"d-flex justify-content-md-end justify-content-sm-center h-100\" data-v-781c5ec4><div class=\"d-flex align-items-center h-100 w-100\" data-v-781c5ec4><div class=\"d-flex flex-column flex-column-fluid align-items-center p-5\" data-v-781c5ec4><div class=\"text-lg-start text-center align-self-lg-end align-self-sm-center\" style=\"max-width:400px;\" data-v-781c5ec4><div data-v-781c5ec4><h1 class=\"fontThree\" data-v-781c5ec4>Bienvenido</h1></div><div data-v-781c5ec4><p class=\"fontFour\" data-v-781c5ec4> Disfrute de la mejor y la más <br data-v-781c5ec4> alta calidad en sensores. </p></div></div></div></div></div></div></div>", 1)
const _hoisted_4 = { class: "col-md-12 col-lg-5 col-sm-12" }
const _hoisted_5 = { class: "d-flex align-items-center h-100 p3-lg-15" }
const _hoisted_6 = { class: "d-flex flex-column flex-column-fluid align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-column flex-column-fluid justify-content-center mb-10" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo",
      src: "media/logos/logo_sens.svg",
      class: "h-100 m-5"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo_title",
      src: "media/logos/logo_title_sens.svg",
      style: {"height":"41px"}
    })
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fs-6" }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Desarrollado por "),
        /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Daily Tech®")
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_router_view)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_8
  ], 64))
}